<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h6 class="prd-h6"> Hearing Dates </h6>
<div class="card" >
    <div class="card-body" *ngIf='displayState.workingDiv'>
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
<br />

<div class="row" *ngIf='this.displayState.newHearingDiv'>
  <div class="col-md-2 offset-1">
      <button class="btn btn-sm btn-link" (click)="newHearing()" [disabled]="userType === 'Read-Only' || userType === 'Appraiser'">New Hearing Date</button>
  </div>
  <div class="col-md-3 offset-md-6">
    <label for="chkActiveOnly">Future Hearings Only?</label>
    <input id="chkActiveOnly" type="checkbox" [(ngModel)]='futureHearingOnly' class="offset-md-1" (change)="filterOnDate()">
  </div>
</div>

<div class="row" *ngIf='displayState.gridDiv'>
  <div class="col-md-10 offset-1">
    <p-table [value]="hearingDateList" [scrollable]="true" scrollHeight="520px"  >
      <ng-template pTemplate="header">
          <tr style="font-size:small;">
              <th style="width: 7%;" >&nbsp;</th>
              <th [pSortableColumn]="'hearingDate'" style="width: 10%;" >
                  Hearing Date
                  <p-sortIcon [field]="'hearingDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'hearingTime'" style="width: 7%;">
                  Time
                  <p-sortIcon [field]="'hearingTime'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'boardNumber'" style="width: 7%;">
                Board
                <p-sortIcon [field]="'boardNumber'"></p-sortIcon>
            </th>
              <th style="width: 25%;">
                Location
              </th>
              <th style="width: 25%;">
                Location 2
              </th>
              <th style="width: 20%;">
                Board Members
              </th>
              <th style="width: 6%;">&nbsp;</th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-hearing>
          <tr style="font-size: small;">
              <td style="width: 7%;">
                  <button class='btn btn-sm btn-link' (click)="onSelect(hearing)">Select</button>
              </td>
              <td style="width: 10%;">{{hearing.hearingDate | date:"MM/dd/yyyy"}}</td>
              <td style="width: 7%;">{{hearing.hearingTime}}</td>
              <td style="width: 7%;">{{hearing.boardNumber}}</td>
              <td style="width: 25%;">{{hearing.meetingLocation?.location}}</td>
              <td style="width: 25%;">{{hearing.meetingLocation?.location2}}</td>
              <!--<td style="width: 20%;">{{hearing.boardMembers[0]?.memberName}}</td> -->
              <td style="width: 20%;">{{getHearingBM(hearing)}}</td>
              <td style="width: 6%;">
                <button class='btn btn-sm btn-link' (click)="deleteHearing(hearing)" [disabled]="userType === 'Read-Only' || userType === 'Appraiser'">Delete</button>
            </td>

          </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<div class="row" *ngIf='displayState.editHearingDiv'>
    <div class="card bg-light col-md-10 offset-1">
        <div class="card-body">
            <div class="form-row">
                <label for="hearingDate" class="col-md-2 col-form-label prd-label">Hearing Date</label>
                <p-calendar id="hearingDate" class="prd-required" [(ngModel)]="myDate" showButtonBar="true"></p-calendar>
                <label for="hearingTime" class="col-md-2 col-form-label prd-label">Hearing Time</label>
                <input type="text" class="form-control col-md-1 prd-required" id="hearingTime" [(ngModel)]="myHearing.hearingTime">
                <label for="boardNumber" class="col-md-2 col-form-label prd-label">Board</label>
                <input type="text" class="form-control col-md-1" id="boardNumber" [(ngModel)]="myHearing.boardNumber">
            </div>
            <br />
            <div class="form-row">
                <label for="location" class="col-md-2 col-form-label prd-label">Location</label>
                <select [(ngModel)]="myHearing.meetingLocationId" id="location" class="form-control col-md-8 prd-required">
                    <option [ngValue]="0"></option>
                    <option [ngValue]="loc.id" *ngFor="let loc of meetingLocationList"> {{ loc.location }} -- {{loc.location2}}</option>
                </select>
            </div>
            <br />
            <div class="form-row">
                <!-- Board Member #1 -->
                <label for="boardMember1" class="col-md-2 col-form-label prd-label">Board Member</label>
                <div class="col-md-1">
                    <select [(ngModel)]="myHearing.boardMembers[0].id" id="boardMember1">
                      <option [ngValue]="0"></option>
                      <option [ngValue]="boardMember.id" *ngFor="let boardMember of boardMemberList" >{{ boardMember?.memberName }}</option>
                  </select>
                  </div>
            </div>
            <br />
            <div class="form-row">
                <!-- Board Member #2 -->
                <label for="boardMember2" class="col-md-2 col-form-label prd-label">Board Member</label>
                <div class="col-md-1">
                    <select [(ngModel)]="myHearing.boardMembers[1].id" id="boardMember2">
                      <option [ngValue]="0"></option>
                      <option [ngValue]="boardMember.id" *ngFor="let boardMember of boardMemberList" >{{ boardMember?.memberName }}</option>
                  </select>
                  </div>
            </div>
            <br />
            <div class="form-row">
                <!-- Board Member #3 -->
                <label for="boardMember3" class="col-md-2 col-form-label prd-label">Board Member</label>
                <div class="col-md-1">
                    <select [(ngModel)]="myHearing.boardMembers[2].id" id="boardMember3">
                      <option [ngValue]="0"></option>
                      <option [ngValue]="boardMember.id" *ngFor="let boardMember of boardMemberList" >{{ boardMember?.memberName }}</option>
                  </select>
                  </div>
            </div>
            <br />
            <div class="form-row">
                <!-- Comment -->
                <label for="comment" class="col-md-2 col-form-label prd-label">Comment</label>
                <input type="text" class="form-control col-md-8" id="comment" [(ngModel)]="myHearing.comment">
            </div>
            <br />
            <div class="form-row">
                <!-- Buttons -->
                <button class="btn btn-success offset-3" (click)="saveHearing()" [disabled] = "displayState.saveDisabled" >Save</button>
                <button class="btn btn-warning offset-1" (click)="cancelEntry()">Cancel</button>
            </div>
        </div>
    </div>
</div>
